import React, { useRef, useState } from "react";
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import { Link } from 'react-router-dom';

import "swiper/css/navigation";
import "./BestPick.css";


import { Navigation } from "swiper";

// Data
import BestPick1 from './PickData1';
import BestPick2 from './PickData2';
import BestPick3 from './PickData3';
import BestPick4 from './PickData4';
import BestPick5 from './PickData5';



function BestPick() {
    const [value, setValue] = React.useState(0);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    let [data1] = useState(BestPick1)
    let [data2] = useState(BestPick2)
    let [data3] = useState(BestPick3)
    let [data4] = useState(BestPick4)
    let [data5] = useState(BestPick5)

    let [res1] = useState([72, 73, 74, 75, 76, 77, 78, 79]);
    let [res2] = useState([80, 81, 82, 83, 84, 85, 86, 87]);
    let [res3] = useState([88, 89, 90, 91, 92, 93, 94, 95]);
    let [res4] = useState([96, 97, 98, 99, 100, 101, 102, 103]);
    let [res5] = useState([104, 105, 106, 107, 108, 109, 110, 111]);

    return (
        <Box sx={{ width: '100%' }}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
                    <Tab label="전체" {...a11yProps(0)} />
                    <Tab label="여성" {...a11yProps(1)} />
                    <Tab label="남성" {...a11yProps(2)} />
                    <Tab label="잡화/슈즈" {...a11yProps(3)} />
                    <Tab label="골프/스포츠" {...a11yProps(4)} />
                </Tabs>
            </Box>
            <TabPanel value={value} index={0} style={{ width: '1240px', margin: '0 auto' }}>
                <div className="Pickboxwrap">
                    <AllBox data1={data1} res1={res1} />
                </div>
            </TabPanel>

            <TabPanel value={value} index={1} style={{ width: '1240px', margin: '0 auto' }}>
                <div className="Pickboxwrap">
                    <WomenBox data2={data2} res2={res2} />
                </div>

            </TabPanel>

            <TabPanel value={value} index={2} style={{ width: '1240px', margin: '0 auto' }}>
                <div className="Pickboxwrap">
                    <MenBox data3={data3} res3={res3} />
                </div>

            </TabPanel>

            <TabPanel value={value} index={3} style={{ width: '1240px', margin: '0 auto' }}>
                <div className="Pickboxwrap">
                    <ShoeBox data4={data4} res4={res4} />
                </div>

            </TabPanel>

            <TabPanel value={value} index={4} style={{ width: '1240px', margin: '0 auto' }}>
                <div className="Pickboxwrap">
                    <GolfBox data5={data5} res5={res5} />
                </div>

            </TabPanel>
        </Box>
    );
}

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 3 }}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        "aria-controls": `simple-tabpanel-${index}`
    };
}


function AllBox(props) {
    return (
        <>
            {
                props.data1.map((a, i) => {
                    return (
                        <div className="Pickbox_wrap" key={i}>
                            <Link to={`/detail/${props.res1[i]}`}>
                                <img src={a.imgurl} />
                                <div className="Pickbox_txt">
                                    <p>{a.brand}</p>
                                    <p>{a.title}</p>
                                    <span>{a.persent}</span><span>{a.price}</span><span>{a.saleprice}</span>
                                </div>
                            </Link>
                        </div>
                    )
                })
            }
        </>
    )
}

function WomenBox(props) {
    return (
        <>
            {
                props.data2.map((a, i) => {
                    return (
                        <div className="Pickbox_wrap">
                            <Link to={`/detail/${props.res2[i]}`}>
                                <img src={a.imgurl} />
                                <div className="Pickbox_txt">
                                    <p>{a.brand}</p>
                                    <p>{a.title}</p>
                                    <span>{a.persent}</span><span>{a.price}</span><span>{a.saleprice}</span>
                                </div>
                            </Link>
                        </div>
                    )
                })
            }
        </>
    )
}

function MenBox(props) {
    return (
        <>
            {
                props.data3.map((a, i) => {
                    return (
                        <div className="Pickbox_wrap">
                            <Link to={`/detail/${props.res3[i]}`}>
                                <img src={a.imgurl} />
                                <div className="Pickbox_txt">
                                    <p>{a.brand}</p>
                                    <p>{a.title}</p>
                                    <span>{a.persent}</span><span>{a.price}</span><span>{a.saleprice}</span>
                                </div>
                            </Link>
                        </div>
                    )
                })
            }
        </>
    )
}

function ShoeBox(props) {
    return (
        <>
            {
                props.data4.map((a, i) => {
                    return (
                        <div className="Pickbox_wrap">
                            <Link to={`/detail/${props.res4[i]}`}>
                                <img src={a.imgurl} />
                                <div className="Pickbox_txt">
                                    <p>{a.brand}</p>
                                    <p>{a.title}</p>
                                    <span>{a.persent}</span><span>{a.price}</span><span>{a.saleprice}</span>
                                </div>
                            </Link>
                        </div>
                    )
                })
            }
        </>
    )
}

function GolfBox(props) {
    return (
        <>
            {
                props.data5.map((a, i) => {
                    return (
                        <div className="Pickbox_wrap">
                            <Link to={`/detail/${props.res5[i]}`}>
                                <img src={a.imgurl} />
                                <div className="Pickbox_txt">
                                    <p>{a.brand}</p>
                                    <p>{a.title}</p>
                                    <span>{a.persent}</span><span>{a.price}</span><span>{a.saleprice}</span>
                                </div>
                            </Link>
                        </div>
                    )
                })
            }
        </>
    )
}


export default BestPick;